import withFeatureFlagToggle from 'components/feature-flag/withFeatureFlagToggle'
import ProviderInfo from 'components/visit-creation/provider-info/ProviderInfo'
import ProviderInfoOld from 'components/visit-creation/provider-info/ProviderInfoOld'
import Provider from 'types/provider/provider'

type ProviderInfoProps = {
  provider: Provider
  isSuccess?: boolean
}

const ProviderInfoToggle = withFeatureFlagToggle<ProviderInfoProps>('tcNewProviderBios')(ProviderInfo, ProviderInfoOld)

export default ProviderInfoToggle
